import particulars from './particulars.vue'
import allocation from './allocation.vue'
import { Collapse } from 'element-ui';
export default {
    components: {
        particulars, allocation
    },
    data() {
        return {

            item: '',
            value: '',
            input1: '',
            input2: '',
            tableData1: [],
            total: 0,
            length: 15,
            offset: 0,
            currentPage: 0,//分页参数  
            search: '',
            dialogVisible: false,
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            dialogVisible4: false,
            restaurants: [],
            state1: '',
            xiangmuname: '',
            xiangmuid: '',
            tableData: '',
            bianji: '',
            peizhi: '',
            label_id: [],
            options1: [],
            form: {
                name: '',
                desc: '',
                start_time: '',
                end_time: '',
                onsale: '',
                sponsor: '',
                organizer: '',
                period: '',
                start_stydy_time: '',
                end_study_time: '',
                scoresOf: '',
            },

        }
    },
    methods: {
		//切换站点数据
		currentProject(type){
			this.state1 = type
			this.currentPage = 1
			this.offset = 0
			this.sousuo()
		},
        closeDialog() {
            this.xxx = '';//清空数据
        },
        // 搜索
        sousuo() {
			this.offset = 0
            if (this.state1 || this.input2) {
                this.$post('projects/shop_search', {
                    offset: this.offset,
                    length: this.length,
                    token: this.$store.state.authority_management,
                    name: this.state1,
                    sponsor: this.input2,
                }).then(res => {
                    this.tableData1 = res.data.result.data
                    this.total = res.data.result.total
					this.currentPage = 1;
                })
            } else {
                this.getxiangmu()

            }
        },
        // 获取班级搜索列表信息
        gethttp1() {
            this.$post('projects/shop_search', {
                offset: this.offset,
                length: this.length,
                token: this.$store.state.authority_management,
                name: this.state1,
                sponsor: this.input2
            }).then(res => {
                this.restaurants = res.data.result.data.map((res, index) => {
                    res.value = res.name;
                    return res;
                })
            })
        },
        // 搜索框函数
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },


        // 分页函数
        handleCurrentChange(val) {
            this.offset = (val - 1) * this.length
            this.getxiangmu()
        },
        handleSizeChange(val) {
            this.offset = 0
            this.length = val
            this.getxiangmu()
        },
        //分页end


        // 获取项目已添加任务列表
        getxiangmurenwu() {
            this.$post('project_tasks/search', {
                offset: 0,
                length: 999,
                token: this.$store.state.authority_management,
                project_id: this.item.id,
            }).then(res => {
                this.tableData = res.data.result.data
            })
        },


        //详情页
        particulars(index, row) {
            // // console.log(row)
            this.dialogVisible1 = true
            this.item = row
            this.getxiangmurenwu()
        },


        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },

        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        //删除
        Delete(index, row) {
            this.$post('projects/delete', {
                id: this.xiangmuid,
                token: this.$store.state.authority_management,
            }).then(res => {
                if (res.data.status == 'success') {
                    // this.gethttp(this.offset,this.length)
                    this.getxiangmu()
                } else {
                    this.defeated()
                }

            })
            this.dialogVisible = false
        },

        // 添加项目
        additem() {
            this.dialogVisible3 = true
            this.initform()
        },

        // 编辑
        update(index, row) {
            this.bianji = row
            this.dialogVisible2 = true
            // // console.log(row)
        },
        // 配置
        all(index, row) {
            this.peizhi = row.id
            this.dialogVisible4 = true
        },

        // 获取项目列表
        getxiangmu() {
            this.$post('projects/shop_search', {
                offset: this.offset,
                length: this.length,
                token: this.$store.state.authority_management,
                name: this.state1,
                sponsor: this.input2
            }).then(res => {
                this.tableData1 = res.data.result.data
                this.total = res.data.result.total
                // // console.log(res.data.result.data)
            })
        },

        //获取标签数据
        getlabels() {
            this.$post('labels/search', {
                offset: 0,
                length: 999,
                token: this.$store.state.authority_management,
            }).then(res => {
                let options = res.data.result.data
                let op = [{ value: '', label: '' }]

                for (let i = 0; i < options.length; i++) {
                    if (options[i].parent_id == 0) {
                        let oppp = {}
                        let children = []
                        oppp.value = options[i].id
                        oppp.label = options[i].name
                        for (let j = 0; j < options.length; j++) {
                            if (options[j].parent_id == options[i].id) {
                                let oppp1 = {}
                                let children1 = []
                                oppp1.value = options[j].id
                                oppp1.label = options[j].name
                                for (let y = 0; y < options.length; y++) {
                                    if (options[y].parent_id == options[j].id) {
                                        let oppp2 = {}
                                        oppp2.value = options[y].id
                                        oppp2.label = options[y].name
                                        children1.push(oppp2)
                                    }
                                }
                                if (children1.length != 0) {
                                    oppp1.children = children1
                                }
                                children.push(oppp1)

                            }
                        }
                        if (children.length != 0) {
                            oppp.children = children
                        }
                        op.push(oppp)
                    }
                }
                this.options1 = op
                // // console.log(res.data.result.data)
            })
        },
        //删除
        open(index, row) {
            this.xiangmuname = row.name
            this.xiangmuid = row.id

            this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.Delete()
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        ///////////////////////////////////////////////////添加项目js///////////////////////////////////////////
        //判断整数
        isInteger(obj) {
            return obj % 1 === 0
        },
        // 提示消息
        tishi(text) {
            this.$message.error(text);
        },
        // 成功消息
        success(text) {
            this.$message({
                message: text,
                type: 'success'
            });
        },
        // 添加项目
        create() {

            let fl = false
            let text = '请输入'
            // // console.log(this.form)
            var start_time = new Date(this.form.start_time).getTime()
            var end_time = new Date(this.form.end_time).getTime()
            var start_stydy_time = new Date(this.form.start_stydy_time).getTime()
            var end_study_time = new Date(this.form.end_study_time).getTime()


            // 校验
            if (this.form.name == '' || this.form.name == null) {
                text = text + '__[项目名称]'
            }
            if (this.form.desc == '' || this.form.desc == null) {
                text = text + '__[描述]'
            }
            // if(this.form.start_time == '' || this.form.end_time  == '' || this.form.start_time == null || this.form.end_time  == null){
            //   text = text + '__[报名时间]'
            //   } 
            // if(this.form.period == '' || this.form.period == null){
            //   text = text + '__[学时]'
            //   }
            // // console.log('分数分数：');
            // // console.log(this.form.scoresOf);
            // // console.log(this.form.sroceOf == ''|| this.form.sroceOf == null);
            // if(this.form.scoresOf == ''|| this.form.scoresOf == null){
            //   text = text + '__[辅导员评分占比]'
            // }

            if (text == '请输入') {
                // if(!this.isInteger(this.form.period)){
                //   this.tishi('学时必须是整数！')
                // }else if(start_time>end_time){
                //   this.tishi('报名截止时间早于报名开始时间！')
                // }else if(start_stydy_time>end_study_time){
                //   this.tishi('培训截止时间早于培训开始时间！')
                // }else if(start_time>start_stydy_time){
                //   this.tishi('培训开始时间早于报名开始时间！')
                // }else if(this.form.scoresOf > 100 || this.form.scoresOf < 0){
                //   this.tishi('辅导员评分占比在0-100之间!')
                // }
                // else{
                fl = true
                // }
            } else {
                this.tishi(text)
            }

            if (this.form.start_stydy_time == '' && this.form.end_study_time == '') {
                if (fl) {
                    this.$post('projects/create', {
                        name: this.form.name,
                        desc: this.form.desc,
                        // start_time :this.form.start_time,
                        // end_time :this.form.end_time,
                        sponsor: this.form.sponsor,
                        organizer: this.form.organizer,
                        period: this.form.period,
                        prportion: this.form.scoresOf,
                        token: this.$store.state.authority_management,
                        shop_id: this.$store.state.store.id
                    }).then(res => {
                        if (res.data.status == 'success') {
                            this.getxiangmu()
                            this.dialogVisible3 = false
                            this.success('添加成功！')
                            this.initform()
                        } else {
                            this.tishi('添加失败！')
                        }

                    })
                }
            } else if (this.form.start_stydy_time != '' && this.form.end_study_time == '') {
                if (fl) {
                    this.$post('projects/create', {
                        name: this.form.name,
                        desc: this.form.desc,
                        // // start_time :this.form.start_time,
                        // end_time :this.form.end_time,
                        // sponsor :this.form.sponsor,
                        // organizer :this.form.organizer,
                        // period :this.form.period,

                        start_stydy_time: this.form.start_stydy_time,

                        token: this.$store.state.authority_management,
                        shop_id: this.$store.state.store.id
                    }).then(res => {
                        if (res.data.status == 'success') {
                            this.getxiangmu()
                            this.dialogVisible3 = false
                            this.success('添加成功！')
                            this.initform()
                        } else {
                            this.tishi('添加失败！')
                        }

                    })
                }
            } else if (this.form.start_stydy_time == '' && this.form.end_study_time != '') {
                if (fl) {
                    this.$post('projects/create', {
                        name: this.form.name,
                        desc: this.form.desc,
                        // // start_time :this.form.start_time,
                        // end_time :this.form.end_time,
                        // sponsor :this.form.sponsor,
                        // organizer :this.form.organizer,
                        // period :this.form.period,

                        end_study_time: this.form.end_study_time,

                        token: this.$store.state.authority_management,
                        shop_id: this.$store.state.store.id
                    }).then(res => {
                        if (res.data.status == 'success') {
                            this.getxiangmu()
                            this.dialogVisible3 = false
                            this.success('添加成功！')
                            this.initform()
                        } else {
                            this.tishi('添加失败！')
                        }

                    })
                }
            } else if (this.form.start_stydy_time != '' && this.form.end_study_time != '') {
                if (fl) {
                    this.$post('projects/create', {
                        name: this.form.name,
                        desc: this.form.desc,
                        // // start_time :this.form.start_time,
                        // end_time :this.form.end_time,
                        // sponsor :this.form.sponsor,
                        // organizer :this.form.organizer,
                        // period :this.form.period,

                        start_stydy_time: this.form.start_stydy_time,
                        end_study_time: this.form.end_study_time,

                        token: this.$store.state.authority_management,
                        shop_id: this.$store.state.store.id
                    }).then(res => {
                        if (res.data.status == 'success') {
                            this.getxiangmu()
                            this.dialogVisible3 = false
                            this.success('添加成功！')
                            this.initform()
                        } else {
                            this.tishi('添加失败！')
                        }

                    })
                }
            }



        },
        //初始化数据
        initform() {
            this.form.name = ''
            this.form.desc = ''
            this.form.start_time = ''
            this.form.end_time = ''
            this.form.onsale = ''
            this.form.sponsor = ''
            this.form.organizer = ''
            this.form.period = ''
            this.form.start_stydy_time = ''
            this.form.end_study_time = ''
        },
        /// ///////////////////////////////////////////////添加项目js end///////////////////////////////////////////


        //////////////////////////////////////////////////更新项目js////////////////////////////////////////////////
        ///  // 更新项目
        createUpdate() {
            let fl = false
            let text = '请输入'


            var start_time = new Date(this.bianji.start_time).getTime()
            var end_time = new Date(this.bianji.end_time).getTime()
            var start_stydy_time = new Date(this.bianji.start_stydy_time).getTime()
            var end_study_time = new Date(this.bianji.end_study_time).getTime()


            // 校验
            if (this.bianji.name == '' || this.bianji.name == null) {
                text = text + '__[项目名称]'
            }
            if (this.bianji.desc == '' || this.bianji.desc == null) {
                text = text + '__[描述]'
            }
            if (this.bianji.start_time == '' || this.bianji.end_time == '' || this.bianji.start_time == null || this.bianji.end_time == null) {
                text = text + '__[报名时间]'
            }
            // if(this.bianji.period == '' || this.bianji.period == null){
            //    text = text + '__[学时]'
            // }

            if (text == '请输入') {
                // if(!this.isInteger(this.bianji.period)){
                //   this.tishi('学时必须是整数！')
                // }else if(start_time>end_time){
                //   this.tishi('报名截止时间早于报名开始时间！')
                // }else 
                if (start_stydy_time > end_study_time) {
                    this.tishi('培训截止时间早于培训开始时间！')
                } else {
                    fl = true
                }
            } else {
                this.tishi(text)
            }

            // // console.log(this.bianji)
            if (fl) {
                // // console.log(this.bianji.prportion)
                this.$post('projects/edit', {
                    id: this.bianji.id,
                    name: this.bianji.name,
                    desc: this.bianji.desc,
                    start_time: this.bianji.start_time,
                    end_time: this.bianji.end_time,
                    sponsor: this.bianji.sponsor,
                    organizer: this.bianji.organizer,
                    period: this.bianji.period,
                    start_stydy_time: this.bianji.start_stydy_time,
                    end_study_time: this.bianji.end_study_time,
                    prportion: this.bianji.prportion,
                    token: this.$store.state.authority_management,
                }).then(res => {
                    if (res.data.status == 'success') {
                        this.success('修改成功！')
                        this.dialogVisible2 = false
                    } else {
                        this.tishi('修改失败！')
                    }

                })
            }

        },
        //////////////////////////////////////////跟新项目 end///////////////////////////////////////////
    },


    created() {
        this.getlabels()
        this.getxiangmu()
        this.gethttp1()


    }
}
